import { useEffect, useState, useContext } from 'react';
import { AppContext } from '../../services/AppContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SpendClass = () => {
    const { t } = useTranslation();
    const { apiClient, isAuthorized, user, notify } = useContext(AppContext);
    const [showModal, setShowModal] = useState(false);
    const [userNotes, setUserNotes] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const handleClose = () => {
        setShowModal(false);
        navigate('/');
    };

    const spendClass = async () => {
        const queryParams = new URLSearchParams(location.search);
        const id = queryParams.get('id');

        if (isAuthorized && user.role === 'Manager') {
            const result = await apiClient.spendClass({
                subscriptionId: id
            });

            if (!result.hasErrors) {
                let message = t('pages.subscriptions.notifications.successRegistered', { remaining: result.after });

                if (result.after === 0) {
                    message = t('pages.subscriptions.notifications.subscriptionOver');
                }

                notify(message, 'success');

                if (result.userNotes) {
                    setUserNotes(result.userNotes);
                    setShowModal(true);

                    return;
                }

                navigate('/');
            }
        }
    };

    useEffect(() => {
        setUserNotes(undefined);
        spendClass();
    }, []);

    return (
        <div>
            {showModal && (
                <div className="modal">
                    <div className="modal-content">
                        <h3>{t('pages.subscriptions.modal.userNotesTitle')}</h3>
                        <div>{userNotes}</div>
                        <button onClick={handleClose}>{t('pages.subscriptions.modal.closeButton')}</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SpendClass;